<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item class="depart-data">
                    <i class="el-icon-s-data" style="margin-right: 10px;"></i>部门数据：<span style="padding-left: 10px;">电话总数：{{phoneCount}}</span>丨<span>微信总数：{{wechatCount}}</span>丨<span>见面总数：{{meetCount}}</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="业务员" id="name">
                    <el-input v-model="dataForm.userName" placeholder="请输入业务员姓名"
                              onkeypress="if(event.keyCode == 13) return false;" clearable></el-input>
                </el-form-item>
                <el-form-item label="日期（部门数据条件）">
                    <el-date-picker
                            v-model="dataForm.dateTemp"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        header-align="center"
                        align="center"
                        width="80"
                        label="编号">
                </el-table-column>
                <el-table-column
                        prop="name"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="业务员">
                </el-table-column>
                <el-table-column
                        prop="isWork"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="!scope.row.isWork">在职</el-tag>
                        <el-tag v-else type="info">离职</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="phoneCount"
                        header-align="center"
                        align="center"
                        sortable
                        :show-overflow-tooltip="true"
                        label="电话数">
                </el-table-column>
                <el-table-column
                        prop="wechatCount"
                        header-align="center"
                        align="center"
                        sortable
                        :show-overflow-tooltip="true"
                        label="微信数">
                </el-table-column>
                <el-table-column
                        prop="meetCount"
                        header-align="center"
                        align="center"
                        sortable
                        :show-overflow-tooltip="true"
                        label="见面数">
                </el-table-column>
                <el-table-column
                        prop="updateTime"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="更新时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-document" size="small"
                                   @click="getInfoHandle(scope.row.id,scope.row.name)">查看数据
                        </el-button>
                        <!--<el-button type="text" icon="el-icon-delete" size="small"-->
                        <!--@click="deleteHandle(scope.row.id)">删除-->
                        <!--</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {IvUser} from "../../api/inviteUser";
    import {DateFormat} from "../../utils/dateformat";

    export default {
        name: "invite-user",
        data() {
            return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                phoneCount: '',
                wechatCount: '',
                meetCount: '',
                dataForm: {
                    userName: '',
                    dateTemp: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {},
        created() {
            this.getDataList();
        },
        activated() {
            this.getDataList();
        },
        methods: {
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            /**
             * 获取数据
             * @param type
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let dateList = this.dataForm.dateTemp ? this.dataForm.dateTemp : [];
                let dateStart = dateList.length === 2 ? DateFormat.dateFormat(dateList[0]) : '';
                let dateEnd = dateList.length === 2 ? DateFormat.dateFormat(dateList[1]) : '';
                let params = {
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize,
                    'name': this.dataForm.userName,
                    'dateStart': dateStart,
                    'dateEnd': dateEnd
                };
                IvUser.getIvUserList(params).then(res => {
                    if (res.code === 0) {
                        this.phoneCount = res.page.phoneCount;
                        this.wechatCount = res.page.wechatCount;
                        this.meetCount = res.page.meetCount;
                        this.dataList = res.page.page.list;
                        this.totalPage = res.page.page.totalCount;
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 个人数据
             * @param id
             */
            getInfoHandle(id, name) {
                localStorage.setItem('userId', id ? id : '0');
                localStorage.setItem('userName', name);
                //console.log(name)
                this.$router.push({path: '/invite-user-list', query: {userId: id, userName: name}});
            }
        }
    }
</script>

<style scoped>

    .depart-data {
        margin: 5px 0;
    }

    .depart-data /deep/ .el-breadcrumb__inner {
        color: #606266;
        padding-left: 10px;
        font-size: 18px;
        letter-spacing: 1px;
    }

    .depart-data /deep/ .el-breadcrumb__inner:hover {
        color: black;
    }

</style>
